export default[
    {
    path: "/ed8cd2617f40b44bdc57f727",
    children: [
    {
        path: "g6eIKzd11c0ffb174b18db93419771sMH5bN",
        name: "list.asset",
        meta: {
          title: "Assets",
          authRequired: true,
          acc: ["y35031"],
        },
        component: () => import("../views/assets-management/list.vue"),
      },
      {
        path: "zgUt4d18feac823df2421dc9e5653fUeiHs/:id?",
        name: "view.asset",
        meta: {
          title: "View Asset",
          authRequired: true,
          acc: ["y64349"],
        },
        component: () => import("../views/assets-management/view.vue"),
      },
      {
        path: "zgUt44d1d11c0ffb174b18db93419771a3a3fUeiHs",
        name: "new.asset",
        meta: {
          title: "New Asset",
          authRequired: true,
          acc: ["y82496"],
        },
        component: () => import("../views/assets-management/new.vue"),
      },
      {
        path: "zgUt44d176b4eda65d5719c766a3a3fUeiHs/:id?",
        name: "edit.asset",
        meta: {
          title: "Edit Asset",
          authRequired: true,
          acc: ["y30311"],
        },
        component: () => import("../views/assets-management/edit.vue"),
      },
    ]
    }


]